
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { User, WalletType, Role } from "../types";

// Mock implementation for services to run in the browser without backend

export const connectWalletService = async (type: WalletType): Promise<string> => {
  await new Promise(resolve => setTimeout(resolve, 800));
  switch (type) {
      case 'phantom': return "SOL_Ph...9x2";
      case 'solflare': return "SOL_Sf...k4m";
      case 'base': return "ETH_Ba...7y1";
      case 'walletconnect': return "WC_0x...3a9";
      case 'suiet': return "SUI_Su...p8l";
      default: return "0x...";
  }
};

export const mockLogin = async (email: string, password: string): Promise<User> => {
  await new Promise(resolve => setTimeout(resolve, 1000));
  if (password === "error") throw new Error("Invalid credentials");
  
  // Assign role based on email for demo purposes
  let role: any = 'client';
  if (email.includes('superadmin')) role = 'superadmin';
  else if (email.includes('admin')) role = 'admin';
  else if (email.includes('merchant')) role = 'merchant';
  else if (email.includes('cashier')) role = 'cashier';

  return { 
    id: 'user_' + Math.random().toString(36).substr(2, 9),
    email, 
    name: email.split('@')[0].toUpperCase(), 
    role,
    status: 'active'
  };
};

export const mockRegister = async (email: string, password: string, name: string, role: Role): Promise<User> => {
    await new Promise(resolve => setTimeout(resolve, 1500));
    return {
        id: 'user_' + Math.random().toString(36).substr(2, 9),
        email: email.toUpperCase(),
        name: name.toUpperCase(),
        role,
        status: 'active',
        created_at: new Date().toISOString().split('T')[0]
    };
};

export const mockWalletLogin = async (type: WalletType): Promise<User> => {
    await new Promise(resolve => setTimeout(resolve, 1500));
    const address = await connectWalletService(type);
    
    return {
        id: 'user_' + Math.random().toString(36).substr(2, 9),
        walletAddress: address,
        walletType: type,
        name: `ANON_${address.slice(-4)}`,
        role: 'merchant', // Default role for wallet logins
        status: 'active'
    };
};
